import { faPen, faSignInAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { IconButton, InputAdornment, OutlinedInput, TextField } from "@mui/material";
import Footer from "components/Layout/Footer";
import React from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import { handleLogin } from '../../actions/LoginAction';
import logoSanef from '../../images/logo.png';
import panneauMDP from '../../images/panneau-mot-de-passe.svg';
import panneauUtilisateur from '../../images/panneau-utilisateur.svg';

class Connexion extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            connection: {
                username: '',
                password: '',
                showPassword: false
            },
            message: this.props.message,
            fetchsRequestConnexion: this.props.fetchsRequestConnexion
        };
        this.currentRef = React.createRef();
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        document.title = "TE - Connexion";
    }

    handleChange = (event) => {
        const champ = event.target.name;
        this.setState({
            connection: {
                ...this.state.connection,
                [champ]: event.target.value.trim()
            }
        });
    }
    handleSubmit = (event) => {
        const connection = this.state.connection;

        if (connection.password !== '' && connection.username !== '') {
            this.props.handleLogin(connection)
        } else {
            this.setState({ message: "Veuillez renseigner un login et un mot de passe" });
        }
    }
    handleKeyDown = (event) => {
        if (event.keyCode === 13) this.handleSubmit();
;    }

    static getDerivedStateFromProps = (props, state) => {
        const derivedState = {};
        if (JSON.stringify(props.fetchsRequestConnexion) !== JSON.stringify(state.fetchsRequestConnexion)) derivedState.fetchsRequestConnexion = props.fetchsRequestConnexion;
        return derivedState;
    }
    componentDidUpdate = (prevProps, prevState) => {
        if (this.props.message !== prevProps.message) {
            this.setState({
                message: this.props.message,
            });
        }
    }
    handleClickShowPassword = () => {
        this.setState({
            connection: {
                ...this.state.connection,
                showPassword: !this.state.connection.showPassword
            }
        });
    };
    handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    render() {
        return (
            <div id="fond">
                {this.state.fetchsRequestConnexion['HANDLE_LOGIN'] > 0 &&
                    <div className="loading" />
                }
                <div id="filtre-rose" />

                <div id="card-connexion">
                    <div id="bloc-logo"><img id="logo" alt='' src={logoSanef} /></div>
                    <div id="barre-rose" />
                    <div className="libelle-form-connexion" id="barre-grise">Transports exceptionnels</div>
                    <div className="error-connexion">{this.state.message}</div>

                    <div id="formulaire-connexion">
                        <div>
                            <img className="panneau" alt='' src={panneauUtilisateur} />
                            <span className="libelle-form-connexion">Login</span>
                            <TextField
                                style={{ marginLeft: '30px', marginTop: '10px' }}
                                className="champ"
                                onChange={this.handleChange}
                                name="username"
                                autoComplete="off"
                                value={this.state.connection.username}
                                variant="outlined"
                                size="small"
                                required
                            />
                        </div>

                        <div style={{ marginTop: '15px' }}>
                            <img className="panneau" alt='' src={panneauMDP} />
                            <span className="libelle-form-connexion">Mot de passe</span>
                            <OutlinedInput
                                style={{ marginLeft: '30px', marginTop: '10px', padding: '0px' }}
                                className="champ"
                                onChange={this.handleChange}
                                onKeyDown={this.handleKeyDown}
                                name="password"
                                autoComplete="off"
                                type={this.state.connection.showPassword ? 'text' : 'password'}
                                value={this.state.connection.password}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={this.handleClickShowPassword}
                                            onMouseDown={this.handleMouseDownPassword}
                                            edge="end"
                                        >
                                            {this.state.connection.showPassword ? <VisibilityOff style={{ marginRight: '15px', padding: '0' }} /> : <Visibility style={{ marginRight: '15px', padding: '0' }} />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                                size="small"
                                required
                            />
                            <Link to={"/mot-de-passe-oublie"} style={{fontSize: '14px', marginLeft: '8%', textDecoration: 'none', color: '#bb0060', fontFamily: 'Gadugi'}}>
                                Mot de passe oublié ?
                            </Link>
                        </div>
                    </div>

                    <div id="buttons-actions-connexion">
                        <button id="btn-connexion" type="submit" onClick={this.handleSubmit}>
                            <span className="error"><FontAwesomeIcon icon={faSignInAlt} /></span>
                            <span className="libelle-form-connexion">Connexion</span>
                        </button>
                        <Link to="inscription" style={{ textDecoration: "none" }}>
                            <button id="btn-inscription" type="button">
                                <span className="error"><FontAwesomeIcon icon={faPen} /></span>
                                <span className="libelle-form-connexion">Inscription</span>
                            </button>
                        </Link>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        message: state.Connexion.message,
        fetchsRequestConnexion: state.Connexion.fetchsRequest
    }
}

function mapDispatchToProps(dispatch) {
    return {
        handleLogin: (data) => dispatch(handleLogin(data)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Connexion)
